/**
 * axios 封装 Vue 插件
 */
'use strict'

// import Vue from 'vue'
import axios from 'axios'
// import store from '@/stores/stores'
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui';
// import * as WikXybSec from './WikXybSec'
NProgress.configure({ showSpinner: false }) // Turn off loading spinner by setting it to false
// Vue.prototype.$http = axios
// 处理请求带token
//axios.interceptors.request.use(
  // config => {
  //   if (sessionStorage.getItem('accessToken')) {
  //     if (config.url.indexOf('?') !== -1) {
  //       if (config.url.indexOf('operateAuth') !== -1) {
  //         config.url = `${config.url}&Authorization=${sessionStorage.getItem('accessToken')}`
  //       } else {
  //         config.url = `${config.url}&Authorization=${sessionStorage.getItem('accessToken')}&operateAuth=-1`
  //       }
  //     } else {
  //       config.url = `${config.url}?operateAuth=-1&Authorization=${sessionStorage.getItem('accessToken')}`
  //     }
  //   }
  //   return config
  // }
  //)

  // 添加请求拦截器
axios.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // 判断是否存在token,如果存在将每个页面header添加token
  if (sessionStorage.getItem("eostoken")) {
    config.headers.common['Authorization'] = sessionStorage.getItem("eostoken");
  }
  return config
}, function (error) {
  router.push('/login')
  return Promise.reject(error)
})
// 异常拦截处理器
const errorHandler = error => {
  // 网络错误或无响应情况
  if (!error.response) {
    return Promise.reject(new Error('网络错误，请检查连接'));
  }

  const { data, status } = error.response;
  
  if (status === 401 || data.code === 401) {
    sessionStorage.clear();
    // 跳转到登录页面
    Message.error(data.msg || 'Failed!');
    location.href = '/#/login';
    return Promise.reject(new Error('未授权，请重新登录'));
  }
  
  return Promise.reject(new Error(error));
}
axios.interceptors.response.use(
  response => {
    if (response.status === 401 || response.data.code === 401) {
      // 清除所有sessionStorage
      sessionStorage.clear();
      Message.error(response.data.msg || 'Failed!');
      // 跳转到登录页面
      location.href = '/#/login';
      return Promise.reject('未授权，请重新登录');
    }
    if (response.data.result === 5) {
      let i = parseInt(sessionStorage.getItem('i')) + 1
      sessionStorage.setItem('i', i)
      if (sessionStorage.getItem('homeType')) {
        if (i === 1) {
          alert(response.data.description)
        }
        location.href = `/#/${sessionStorage.getItem('homeType')}/login` // 本地
        // location.href = `/dist/#/${sessionStorage.getItem('homeType')}/login` // 线上
      } else {
        location.href = `/#/system/login` // 本地
        // location.href = `/dist/#/system/login` // 线上
      }
    }
    return response
  }, errorHandler)
  
// 访问日志：只在开发环境会有，便于前端调试
let logger = (stat, method, url, message) => {
  // 只有开发环境打印日志
  // if (process.env.NODE_ENV !== 'development') return
  // console.info('%s %s %s.', stat, method, url || '未知url', message || '')
}
// 定义超时时间 ms
// let timeout = 10000

// http 成功 response 处理
let sucRespHandle = (response, resolve, reject, method, url) => {
    // 访问日志
  logger('business ok.', method, url)

// 根据后端返回的数据进行解密
  // 解密信息
  // let responseData = WikXybSec.decrypt3DES(response.body)
  let responseData = response.data

  // 转化成json格式
  // let data = JSON.parse(responseData)
  // 消息提示
  // this.$Message.success('请求成功')
    // 返回 Fulfilled 状态的 promise 对象
  resolve(responseData)
}

// http 失败 response 处理
let errRespHandle = (response, resolve, reject, method, url) => {
  // 访问日志
  logger('http fail.', method, url, response)

  let body = response || {}
  let data = body.data || {}

  // 消息提示
  // this.$Message.error('请求失败')

  // 返回 Fulfilled 状态的 promise 对象
  reject(data)
}

// http get 方法
let httpGet = (url, params) => {
  // 进度条
  NProgress.start()

  // 校验url
  if (!url) {
    logger('http fail.', 'get', url)
  }

  // 返回 promise 对象
  return new Promise((resolve, reject) => {
    // 传给后端的数据进行加密
    let strData = JSON.stringify(params)
    // let sendData = WikXybSec.encrypt3DES(strData)
    let sendData = strData
    axios.get(url, { params: sendData }).then(

      // vue get Promise stat 为 Fulfilled
      response => {
        // 关闭进度条
        NProgress.done()

        sucRespHandle(response, resolve, reject, 'get', url)
      },

      // vue get Promise stat 为 Rejected
      response => {
        // 关闭进度条
        NProgress.done()

        errRespHandle(response, resolve, reject, 'get', url)
      }
    )
  })
}

let httpPost = (url, body, options = {}) => {
  // 开启进度条
  if (!options.noProgress) {
    NProgress.start()
  }

  // 校验url
  if (!url) {
    logger('http fail.', 'post', url)
  }

  // 返回 promise 对象
  return new Promise((resolve, reject) => {
    const config = {
      ...options,
      onUploadProgress: progressEvent => {
        // 如果有传入进度回调函数，则调用
        if (options.onUploadProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          options.onUploadProgress(percentCompleted, progressEvent)
        }
      }
    }

    axios.post(url, body || {}, config).then(
      // vue post Promise stat 为 Fulfilled
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        // 成功逻辑
        sucRespHandle(response, resolve, reject, 'post', url)
      },
      // vue post Promise stat 为 Rejected
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        // 失败逻辑
        errRespHandle(response, resolve, reject, 'post', url)
      }
    )
  })
}

let httpPut = (url, body, options = {}) => {
  if (!options.noProgress) {
    NProgress.start()
  }
  if (!url) {
    logger('http fail.', 'put', url)
  }
  return new Promise((resolve, reject) => {
    axios.put(url, body || {}, options).then(
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        sucRespHandle(response, resolve, reject, 'put', url)
      },
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        errRespHandle(response, resolve, reject, 'put', url)
      }
    )
  })
}
let httpDelete = (url, options = {}) => {
  if (!options.noProgress) {
    NProgress.start()
  }
  if (!url) {
    logger('http fail.', 'delete', url)
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, options).then(
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        sucRespHandle(response, resolve, reject, 'delete', url)
      },
      response => {
        if (!options.noProgress) {
          NProgress.done()
        }
        errRespHandle(response, resolve, reject, 'delete', url)
      }
    )
  })
}
export default {
  install: Vue => {
      // get 方法
    Vue.prototype._get = httpGet

      // post 方法
    Vue.prototype._post = httpPost

      // put 方法
    Vue.prototype._put = httpPut

      // delete 方法
    Vue.prototype._delete = httpDelete

      // 全局 get 方法
    Vue._get = httpGet

      // 全局 post 方法
    Vue._post = httpPost

      // 全局 put 方法
    Vue._put = httpPut

      // 全局 delete 方法
    Vue._delete = httpDelete
  }
}



// WEBPACK FOOTER //
// ./src/utils/http.js